import React, { useState, useEffect } from 'react';

// material-ui
import { Box, Card, Grid, Typography, Avatar, Button, Switch, FormControlLabel, Checkbox } from '@mui/material';

import { currencyFormat } from 'helper/NumberFormat';

// project imports
import MainCard from 'ui-component/cards/MainCard';

import { getCoupons } from 'services/couponServices';
import { TCLabel, TCPlace } from 'components/TopCourtComponents/Label/TopCourtLabel';
import TableComponent from 'components/TopCourtComponents/Table/TableComponent';
import CouponFilter from './couponFilter';
import moment from 'moment';
import { useNavigate } from 'react-router';
import { useDebounce } from 'use-debounce';
import { getUrlCourtCode } from 'helper/Court';
import { checkIsSAdmin, isMerchant } from 'helper/Admin';
import { color } from 'constant/constant';

const initFilter = {
    name: '',
    codePromo: '',
    discountType: null,
    status: null,
    createdDate: null,
    expiredDate: null,
    page: 0
}

export default function Coupon({

}) {
    const [rows, setRows] = useState([])
    const [totalData, setTotalData] = useState(0)
    const [filter, setFilter] = useState(initFilter)
    const navigate = useNavigate()
    const [debounceFilter] = useDebounce(filter, 500)
    const [isGlobal, setIsGlobal] = useState(true)

    useEffect(() => {
        loadData()
    }, [debounceFilter])

    const loadData = async () => {
        let { data, error } = await getCoupons({
            name: filter.name ? filter.name : '',
            promo: filter.codePromo ? filter.codePromo : '',
            type: filter.discountType ? filter.discountType.value : '',
            isActive: filter.status ? filter.status.value : '',
            createdDate: filter.createdDate ? filter.createdDate : '',
            expiredDate: filter.expiredDate ? filter.expiredDate : '',
            page: filter.page ? filter.page : 0,
            isGlobal: isGlobal
        });
        console.log(data)
        setRows(data.data)
        setTotalData(data.totalData)
    }

    let place = JSON.parse(localStorage.getItem("court_place"))

    const valueCustomator = (row) => {
        return ({
            createdDate: <TCLabel>{moment(row.createdDate).format("YYYY/MM/DD HH:mm:ss")}</TCLabel>,
            name: <span className='span-link' onClick={() => { navigate(`/${getUrlCourtCode()}/coupons/edit/${row._id}`) }}>{row.name}</span>,
            promo: <TCLabel>{row.promoCode}</TCLabel>,
            type: <TCLabel>{row.promoCodeType.charAt(0).toUpperCase() + row.promoCodeType.slice(1)}</TCLabel>,
            amount: <TCLabel>{row.promoCodeType == 'percentage' ? `${row.amount}%` : currencyFormat(row.amount)}</TCLabel>,
            minRequirement: <TCLabel>{
                row.minimumPurchase ? currencyFormat(row.minimumPurchase) :
                    row.minimumSessions ? `${row.minimumSessions} Session(s)` : '-'
            }</TCLabel>,
            startDate: <TCLabel>{moment(row.startDate).format("YYYY/MM/DD")}</TCLabel>,
            expiryDate: <TCLabel>{moment(row.endDate).format("YYYY/MM/DD")}</TCLabel>,
            total: <TCLabel>{row.limit ? `${row.usage || 0}/${row.limit}` : `-`}</TCLabel>,
            // location: <TCLabel>{row.placeIds.map(v => { return v.name })}</TCLabel>
            location: <div style={{ display: 'flex', gap: 4 }}>{
                row.placeIds.map(v => {
                    return (
                        <TCPlace>
                            {v._id.toString() && place ? (place.find(court => court.id == v._id.toString()).title.toUpperCase()) : 'STC'}
                        </TCPlace>
                    )
                })}</div>
            // action: <Switch checked={row.isActive} />,
            // total: <TCLabel>{row.totalSession}</TCLabel>,
        })
    }

    const onChangeFilter = (e) => {
        setFilter(prev => ({
            ...prev,
            ...e,
            page: 0
        }))
    }

    const onChangePage = (e) => {
        setFilter(prev => ({
            ...prev,
            ...e,
        }))
    }

    const clearFilter = () => {
        setFilter(initFilter)
    }

    useEffect(() => {
        loadData()
    }, [isGlobal])

    return (
        <>
            {
                checkIsSAdmin() &&
                <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                    <Button sx={{ mb: 2 }} variant="contained" disableElevation onClick={() => {
                        navigate(`/${getUrlCourtCode()}/coupons/add`)
                    }}>Add Promo Code</Button>
                    {/* <FormControlLabel
                    label="Global"
                    control={<Checkbox
                        id="value-pack-merchant-checkbox"
                        checked={isGlobal}
                        onChange={() => {
                            let global = !isGlobal
                            setIsGlobal(global)
                        }}
                    />}
                /> */}
                </Box>
            }
            <CouponFilter filter={filter} onChangeFilter={onChangeFilter} clearFilter={clearFilter} />
            <TableComponent
                columns={[
                    { label: "Created Date" },
                    { label: "Promo Title" },
                    { label: "Promo Code" },
                    { label: "Disc Type" },
                    { label: "Disc Amount" },
                    { label: "Min Requirement" }, // purchase ttp ID, session pakai x sessions
                    { label: "Start Date" },
                    { label: "Expiry Date" },
                    { label: "Limit Global" }, // ikutin ideal datanya
                    { label: "Location" }, // ikutin ideal datanya
                    // { label: "" },
                ]}
                rows={rows}
                valueCustomator={valueCustomator}
                totalData={totalData}
                page={filter.page}
                pageChange={(e) => {
                    onChangePage({ page: e })
                }}
            />
        </>
    )
}